export default __webpack_public_path__ + "static/media/smart-plug-image.97c5d8bd.png";